<template>
  <div>
    <div class="header">
      <div class="container">
        <el-row type="flex" justify="space-between">
          <!-- logo -->
          <div class="logo">
            <a href="/">
              <div class="logo-title">首页</div>
            </a>
          </div>

          <el-menu
            :default-active="activeIndex"
            mode="horizontal"
            router
            @select="handleSelect"
            background-color="#353535"
            text-color="#fff"
            active-text-color="#ff9b24"
          >
            <!-- <el-menu-item index="/index">首页</el-menu-item> -->
            <el-menu-item index="/trade">交易中心</el-menu-item>
            <el-menu-item index="/news">新闻资讯</el-menu-item>
            <el-menu-item index="/app">APP介绍</el-menu-item>
            <el-menu-item index="/about">关于我们</el-menu-item>
          </el-menu>
        </el-row>
      </div>
    </div>

    <div class="container main">
      <keep-alive v-if="$route.meta.keepAlive">
        <router-view></router-view>
      </keep-alive>

      <router-view v-if="!$route.meta.keepAlive"></router-view>

      <!-- app跳下载页面 -->
      <!-- <div class="download"></div> -->
    </div>

    <div class="footer">
      <div class="container">
        <p>
          <!-- <a class="copyright" href="https://beian.miit.gov.cn/" target="_blank">陕ICP备2024055561号</a>
          <span style="margin-left: 3px;">陕ICP备2024055561号-2</span> -->
          <a class="copyright" href="https://beian.miit.gov.cn/" target="_blank">陕ICP备2024055561号-2</a>
        </p>
        <p>健康游戏忠告： 抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防上当受骗 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "basic-layout",
  data() {
    return {
      activeIndex: this.$route.meta.index,
    }
  },

  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
  }
};
</script>

<style lang="scss">
.header {
  background-color: var(--black);
  .logo {
    text-align: center;
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    a { color: var(--theme); }
    a .logo-title { font-size: 20px; }
    a .logo-subtitle { font-size: 12px; }
  }
}

.main {
  padding: 20px 0;
}

.footer {
  background-color: var(--black);
  padding: 25px 0;
  font-size: 13px;
  text-align: center;
  .copyright {
    color: #999;
    &:hover {
      text-decoration: revert;
    }
  }
}
</style>
